import http from './http-util'
import config from '../../../config'

const createCustomerRequestBody = ({
  reference,
  customer: { governmentId, customerType } = {},
}) =>
  JSON.stringify({
    ...(reference && { reference }),
    ...((governmentId || customerType) && {
      customer: {
        ...(governmentId && { governmentId }),
        ...(customerType && { customerType }),
      },
    }),
  })

class MerchantPortalBonusCheckServiceApi {
  static getBonusCheckSupport = token =>
    http.get(
      token,
      `${config.merchantPortalBonusCheckServiceUrl}/bonus_checks/support`,
    )

  static bonusCheckRedeem = req => token =>
    http.post(
      token,
      `${config.merchantPortalBonusCheckServiceUrl}/bonus_checks/redeem`,
      createCustomerRequestBody(req),
    )

  static bonusCheckSearch = req => token =>
    http.post(
      token,
      `${config.merchantPortalBonusCheckServiceUrl}/bonus_checks/search`,
      createCustomerRequestBody(req),
    )
}

export default MerchantPortalBonusCheckServiceApi
